import { Controller } from '@hotwired/stimulus'
import { MAX_RESOLUTION_NAME_LENGTH } from './constants'
import {
  CONFIRM_ARCHIVE_RESOLUTION,
  CONFIRM_ARCHIVE_RESOLUTION_DESCRIPTION,
  PLEASE_ENTER_RESOLUTION_NAME,
  RESOLUTION_NAME_TOO_LONG,
  RESOLUTION_NAME_ALREADY_EXISTS,
  trans
} from '../../translator'

export default class extends Controller {
  static values = {
    id: String,
    name: String,
    isQuantityRequired: Boolean
  }

  archive () {
    const modal = this.prepareModal('#confirmationModal', {
      title: trans(CONFIRM_ARCHIVE_RESOLUTION, {}, 'resolutions'),
      body: trans(CONFIRM_ARCHIVE_RESOLUTION_DESCRIPTION, {}, 'resolutions')
    })

    const confirmBtn = document.getElementById('confirmationModalConfirm')

    confirmBtn.onclick = async () => {
      this.hideError(modal)
      this.setButtonState(confirmBtn, true)

      try {
        const response = await fetch(`/resolution/${this.idValue}/archive`, { method: 'POST' })

        if (response.ok) {
          $(modal).modal('hide')
          this.element.remove()
        } else {
          this.showError(modal)
        }
      } catch (error) {
        this.showError(modal)
      } finally {
        this.setButtonState(confirmBtn, false)
      }
    }

    $(modal).modal('show')
  }

  rename () {
    const modal = this.prepareModal('#renameResolutionModal')
    const input = modal.querySelector('input')
    const confirmBtn = modal.querySelector('#confirmRenameResolutionButton')
    const form = document.querySelector('#renameResolutionForm')
    const currentId = this.idValue
    const groupElement = this.element.closest('[data-controller="resolution-group"]')

    $.fn.form.settings.rules.uniqueResolutionName = (value) => {
      const normalised = value.trim().toLowerCase()
      return !Array.from(groupElement?.querySelectorAll('[data-controller="resolution"]') ?? [])
        .some(el => el.dataset.resolutionIdValue !== currentId &&
          el.dataset.resolutionNameValue.toLowerCase() === normalised)
    }

    $(form).form('destroy')
    form.querySelectorAll('.prompt.label').forEach(el => el.remove())
    form.querySelectorAll('.field').forEach(el => el.classList.remove('error'))
    form.classList.remove('error')
    $(form).form({
      fields: {
        rename_resolution_name: {
          rules: [
            {
              type: 'empty',
              prompt: trans(PLEASE_ENTER_RESOLUTION_NAME, {}, 'resolutions')
            },
            {
              type: `maxLength[${MAX_RESOLUTION_NAME_LENGTH}]`,
              prompt: trans(RESOLUTION_NAME_TOO_LONG, { '%parameter%': MAX_RESOLUTION_NAME_LENGTH }, 'resolutions')
            },
            {
              type: 'uniqueResolutionName',
              prompt: trans(RESOLUTION_NAME_ALREADY_EXISTS, {}, 'resolutions')
            }
          ]
        }
      },
      inline: true,
      keyboardShortcuts: false
    })

    confirmBtn.onclick = async () => {
      if (!$(form).form('is valid')) {
        $(form).form('validate form')
        return
      }

      this.hideError(modal)
      this.setButtonState(confirmBtn, true)

      try {
        const payload = { name: input.value }
        const response = await fetch(`/resolution/${this.idValue}/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })

        if (response.ok) {
          const data = await response.json()
          this.element.outerHTML = data.resolution
          $(modal).modal('hide')
        } else {
          this.showError(modal)
        }
      } catch (error) {
        this.showError(modal)
      } finally {
        this.setButtonState(confirmBtn, false)
      }
    }

    input.value = this.nameValue
    $(modal).one('shown.bs.modal', () => input.focus())
    $(modal).modal('show')
  }

  async toggleQuantityRequired (event) {
    event.preventDefault()
    const checkbox = event.currentTarget.querySelector('input[type="checkbox"]')
    const newValue = !checkbox.checked
    checkbox.checked = newValue
    try {
      const response = await fetch(`/resolution/${this.idValue}/toggle-quantity-required`, { method: 'POST' })
      if (!response.ok) {
        checkbox.checked = !newValue
      }
    } catch (error) {
      checkbox.checked = !newValue
    }
  }

  prepareModal (selector, content = {}) {
    const modal = document.querySelector(selector)
    this.hideError(modal)

    if (content.title) modal.querySelector('.modal-title').textContent = content.title
    if (content.body) modal.querySelector('.modal-body .content').textContent = content.body

    const errorDismissBtn = modal.querySelector('.modal-error button')
    if (errorDismissBtn) {
      errorDismissBtn.onclick = () => this.hideError(modal)
    }

    return modal
  }

  showError (modal) {
    modal.querySelector('.modal-error').classList.remove('d-none')
  }

  hideError (modal) {
    modal.querySelector('.modal-error').classList.add('d-none')
  }

  setButtonState (btn, isLoading) {
    if (!btn) return
    btn.disabled = isLoading
    const icon = btn.querySelector('i')
    if (icon) {
      isLoading ? icon.classList.remove('d-none') : icon.classList.add('d-none')
    }
  }
}
